<template>
  <div>
    <!-- pc版 -->
    <div class="feature-wrap" id="feature">
      <div class="title">{{ title }}</div>
      <div class="feature-con">
        <div class="feature" v-for="(item, index) in featureList" :key="index">
          <img class="img" :src="item.imgSrc" />
          <div class="text">{{ item.title }}</div>
          <div class="des">{{ item.des }}</div>
        </div>
      </div>
    </div>
    <!-- h5版 -->
    <div class="feature-wrap-mobile" id="feature">
      <div class="title">{{ title }}</div>
      <div class="feature-con">
        <div class="feature" v-for="(item, index) in featureList" :key="index">
          <img class="img" :src="item.imgSrc" />
          <div class="text">{{ item.title }}</div>
          <div class="des">{{ item.des }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    featureList: Array,
  },
  data() {
    return {}
  },
  methods: {
    changeNav(index) {
      this.navList.forEach(e => {
        e.active = false
      })
      this.navList[index].active = true
    },
  },
  computed: {},
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 768px) {
  .feature-wrap-mobile {
    display: none;
  }
  .feature-wrap {
    background: #ffffff;
    padding-top: 70px;
    padding-bottom: 70px;
    width: 100%;
    .title {
      font-size: 40px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      line-height: 56px;
      text-align: center;
      background: #ffffff;
    }
    .feature-con {
      max-width: 1400px;
      margin: 0 auto;
      display: flex;
      align-content: center;
      justify-content: space-between;
      padding-top: 70px;
      background: #ffffff;
      .feature {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        padding: 44px 35px 36px;
        width: 330px;
        height: auto;
        background: #ffffff;
        border: 1px solid #eeeeee;
        margin: 0 20px;

        .img {
          display: block;
          width: 70px;
          height: 70px;
          margin-bottom: 10px;
        }
        .text {
          font-size: 20px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #202640;
          line-height: 28px;
          margin-bottom: 32px;
        }
        .des {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #202640;
          line-height: 26px;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .feature-wrap {
    display: none;
  }
  .feature-wrap-mobile {
    padding: 1.3333rem 0.7467rem 1.6rem;
    .title {
      text-align: center;
      font-size: 0.5867rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      line-height: 0.6933rem;
    }
    .feature {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .img {
        margin-top: 1.0667rem;
        width: 1.8667rem;
        height: 1.8667rem;
      }
      .text {
        margin-top: 0.08rem;
        font-size: 0.4267rem;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #202640;
        line-height: 0.5867rem;
      }
      .des {
        margin-top: 0.4rem;
        font-size: 0.3733rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #202640;
        line-height: 0.64rem;
        text-align: left;
      }
    }
  }
}
</style>
